'use client';

import { RoiValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  values: RoiValues;
  onValuesChange: (field: keyof RoiValues, value: number) => void;
  translations: ToolsTranslations['roi'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const handleChange = (field: keyof RoiValues) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\s/g, '').replace(/,/g, '.');
    const value = Number(raw);
    onValuesChange(field, isNaN(value) ? 0 : value);
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.investedCapital}</label>
        <input type="text" value={values.investedCapital.toLocaleString('sv-SE')} onChange={handleChange('investedCapital')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.finalValue}</label>
        <input type="text" value={values.finalValue.toLocaleString('sv-SE')} onChange={handleChange('finalValue')} className={inputClass} placeholder="0" />
      </div>
    </div>
  );
}


